(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const isMobile = () => MOBILE_MQ.matches;
  function initPicker(picker) {
    if (picker.dataset.lvInit === '1') return;
    picker.dataset.lvInit = '1';
    const trigger = picker.querySelector('.lv-dropdown__trigger');
    const list = picker.querySelector('.lv-dropdown__list');
    let modal = null;
    let portalList = null; // geklonte Liste im <body>
    function positionPortalList() {
      if (!portalList) return;
      const rect = trigger.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const listHeight = Math.min(380, portalList.scrollHeight);
      const openUpwards = spaceBelow < listHeight + 16 && rect.top > listHeight + 16;
      portalList.style.position = 'fixed';
      portalList.style.left = rect.left + 'px';
      portalList.style.width = rect.width + 'px';
      if (openUpwards) {
        portalList.style.top = 'auto';
        portalList.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
      } else {
        portalList.style.top = (rect.bottom + 4) + 'px';
        portalList.style.bottom = 'auto';
      }
    }
    function openDesktop() {
      closeDesktop();
      portalList = list.cloneNode(true);
      portalList.hidden = false;
      portalList.classList.add('lv-dropdown__list--portal');
      document.body.appendChild(portalList);
      positionPortalList();
      window.addEventListener('scroll', positionPortalList, true);
      window.addEventListener('resize', positionPortalList);
    }
    function closeDesktop() {
      if (portalList) {
        portalList.remove();
        portalList = null;
      }
      window.removeEventListener('scroll', positionPortalList, true);
      window.removeEventListener('resize', positionPortalList);
    }
    function openDropdown() {
      if (isMobile()) openModal();
      else openDesktop();
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeDropdown() {
      closeDesktop();
      closeModal();
      trigger.setAttribute('aria-expanded', 'false');
    }
    function toggleDropdown(e) {
      e.preventDefault(); e.stopPropagation();
      const open = trigger.getAttribute('aria-expanded') === 'true';
      open ? closeDropdown() : openDropdown();
    }
    function openModal() {
      closeModal();
      modal = document.createElement('div');
      modal.className = 'lv-modal';
      modal.innerHTML = `
        <div class="lv-modal__overlay" data-lv-close></div>
        <div class="lv-modal__dialog" role="dialog" aria-modal="true" aria-label="Variante wählen">
          <div class="lv-modal__header">
            <span class="lv-modal__title">Variante wählen</span>
            <button type="button" class="lv-modal__close" aria-label="Schließen" data-lv-close>&times;</button>
          </div>
          <div class="lv-modal__body"></div>
        </div>`;
      document.body.appendChild(modal);
      const clone = list.cloneNode(true);
      clone.hidden = false;
      clone.classList.add('lv-dropdown__list--in-modal');
      modal.querySelector('.lv-modal__body').appendChild(clone);
      modal.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-lv-close')) closeDropdown();
      });
      document.body.classList.add('lv-modal-open');
    }
    function closeModal() {
      document.querySelectorAll('.lv-modal').forEach(m => m.remove());
      document.body.classList.remove('lv-modal-open');
      modal = null;
    }
    trigger.addEventListener('click', toggleDropdown);
    document.addEventListener('click', (e) => {
      if (isMobile() || modal) return;
      if (picker.contains(e.target)) return;
      if (portalList && portalList.contains(e.target)) return;
      closeDropdown();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDropdown();
    });
    MOBILE_MQ.addEventListener('change', () => closeDropdown());
  }
  function initAll() {
    document.querySelectorAll('.lv-dropdown').forEach(initPicker);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();